import { z } from 'zod';

export const InvestmentPropsSchema = z.object({
  external_id: z.string().optional(),
  name: z.string().min(1, 'Name is required'),
  status: z.string().min(1, 'Status is required'),
  investment_type: z.string().min(1, 'Investment type is required'),
  investment_date: z.string(),
  invested_amount: z.number().positive(),
  ownership_percentage: z.number().min(0).max(100).optional(),
  is_follow_on: z.boolean().optional(),
  success_metrics: z.array(z.string()).optional(),
  key_assumptions: z.array(z.string()).optional(),
});

export const ExternalFundPropsSchema = z.object({
  external_id: z.string().optional(),
  name: z.string().min(1, 'Name is required'),
  strategy: z.string().optional(),
  vintage_year: z.number().int().optional(),
  status: z.string().min(1, 'Status is required'),
});

export type InvestmentProps = z.infer<typeof InvestmentPropsSchema>;
export type ExternalFundProps = z.infer<typeof ExternalFundPropsSchema>;
